var $form = document.querySelector('.js-info-form');
var $zipFields = document.querySelectorAll("[data-city-id]");

var zipValidation = {
  init: function() {
    var self = this;
    $zipFields.forEach(($zipField) => {
      var $countryField = document.getElementById(
        $zipField.getAttribute("data-country-id")
      );
      var $cityField = document.getElementById(
        $zipField.getAttribute("data-city-id")
      );

      self.updateZipField($zipField, $countryField.value);
      $countryField.addEventListener("change", function(e) {
        $zipField.value = "";
        $cityField.value = "";
        self.updateZipField($zipField, $countryField.value);
      });
    });
  },
  updateZipField: function($zipField, country) {
    if (country === "DK") {
      $zipField.setAttribute("maxlength", "4");
      $zipField.setAttribute("pattern", $zipField.getAttribute("data-pattern"));
    } else {
      $zipField.removeAttribute("maxlength");
      $zipField.removeAttribute("pattern");
      $zipField.classList.remove('is-invalid');
      if($form)
        $form.classList.remove('js-invalid-zip');
    }
  },
};

export default zipValidation;
